// @flow

// Somewhat arbitrary min-height for an action node
const MIN_HEIGHT = 60;
// Returns the max height in an array of nodes
// Used for sequence diagrams so we know where to position the nodes
export const getMaxHeight = (nodes: Array<any>): number => {
  const actionNodes = nodes.filter((n) => n.type === 'sequenceAction');
  return actionNodes.reduce(
    (prev, curr) => Math.max(prev, curr.__rf.height),
    MIN_HEIGHT,
  );
};
